module.exports = __webpack_public_path__ + "static/ogImage-b41d1dec9609ef1b9cb86a86556f309e.png";